import React from 'react';
import {Link} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IMAGES } from './theme';
import MainBanner from '../components/MainBanner';


const Footer = () => {
    const { t } = useTranslation();
    let date = new Date();
    return (
        <>
            <footer className='site-footer'>
                <MainBanner />
                <div className="container">
                    <div className="footer-info">
                        <div className="row align-items-center">
                            <div className="col-lg-4 order-lg-1 order-2">
                                <div className="footer-call">
                                    <p>{t('footer.callNow')}:</p>
                                    <a href="tel:+34614005838">+34 614 005 838</a>
                                </div>
                            </div>
                            <div className="col-lg-4 order-lg-2 order-1">
                                <div className="footer-logo">
                                    <Link to={"/"}>
                                        <img src={IMAGES.logoOneKeyWithOuColor} alt="Logo" />
                                    </Link>
                                </div>
                            </div>
                            <div className="col-lg-4 order-lg-3 order-3">
                                <div className="social-icon">
                                    <a href={"https://www.facebook.com/purekeyhomes"} target="_blank" rel="noopener noreferrer"><i className="fa fa-facebook"/></a>
                                    <a href={"https://www.instagram.com/purekeyhomes/"} target="_blank" rel="noopener noreferrer"><i className="fa fa-instagram"/></a>
                                    <a href={"https://www.tiktok.com/@purekeyhomes"} target="_blank" rel="noopener noreferrer" className="social-icon-tiktok">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 00-.79-.05 6.27 6.27 0 00-6.27 6.27 6.27 6.27 0 006.27 6.27 6.27 6.27 0 006.26-6.27V9.17a8.16 8.16 0 004.84 1.57V7.3a4.84 4.84 0 01-1-.61z"/>
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-3 col-md-6 order-lg-1 order-1">
                            <div className="footer-about">
                                <h3 className="h3-title footer-title">{t('footer.aboutUsTitle')}</h3>
                                <p>{t('footer.aboutUsText')}</p>
                                <Link to={"/contact"} className="sec-btn" title="Join Us Now"><span>{t('footer.contactUsNow')}</span></Link>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 order-lg-2 order-3">
                            <div className="our-links">
                                <h3 className="h3-title footer-title">{t('footer.ourLinks')}</h3>
                                <ul>
                                    <li><Link to={"/"} >{t('nav.home')}</Link></li>
                                    <li><Link to={"/about-us"} >{t('nav.aboutUs')}</Link></li>
                                    <li><Link to={"/services"} >{t('nav.services')}</Link></li>
                                    <li><Link to={"/contact"}>{t('nav.contactUs')}</Link></li>
                                    <li><Link to={"/pricing"} >{t('nav.pricing')}</Link></li>
                                    <li><Link to={"/team"} >{t('nav.team')}</Link></li>
                                    <li><Link to={"/faq"} >{t('nav.faq')}</Link></li>
                                    <li><Link to={"/blog-list"} >{t('nav.blog')}</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 order-lg-3 order-3">
                            <div className="footer-service">
                                <h3 className="h3-title footer-title">{t('footer.ourServices')}</h3>
                                <ul>
                                    <li><Link to="/services" style={{ color: '#ffffff' }}>{t('footer.propertyManagement')}</Link></li>
                                    <li><Link to="/services" style={{ color: '#ffffff' }}>{t('footer.keyHolding')}</Link></li>
                                    <li><Link to="/services" style={{ color: '#ffffff' }}>{t('footer.meetAndGreet')}</Link></li>
                                    <li><Link to="/services" style={{ color: '#ffffff' }}>{t('footer.cleaningService')}</Link></li>
                                    <li><Link to="/services" style={{ color: '#ffffff' }}>{t('footer.laundryService')}</Link></li>
                                    <li><Link to="/services" style={{ color: '#ffffff' }}>{t('footer.propertyCheck')}</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 order-lg-4 order-2">
                            <div className="footer-contact">
                                <h3 className="h3-title footer-title">{t('footer.contactUsTitle')}</h3>
                                <div className="footer-contact-link">
                                    <span className="icon"><i className="fa fa-map-marker"/></span>
                                    <span style={{ color: '#ffffff' }}>Los Alcazares, Murcia, Spain</span>
                                </div>
                                <div className="footer-contact-link">
                                    <span className="icon"><i className="fa fa-phone"/></span>
                                    <a href="tel:+34614005838">+34 614 005 838</a>
                                </div>
                                <div className="footer-contact-link">
                                    <span className="icon"><i className="fa fa-envelope"/></span>
                                    <a href="mailto:info@pure-key-homes.es">info@pure-key-homes.es</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <div className="footer-last">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="copy-right">
                                <p>{t('footer.copyright', { year: date.getFullYear() })}</p>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="footer-last-link">
                                <ul>
                                    <li><Link to={"/privacy-policy"}>{t('footer.privacyPolicy')}</Link></li>
                                    <li><Link to={"/terms-of-service"}>{t('footer.termsOfService')}</Link></li>
                                    <li><Link to={"/legal"}>{t('footer.legal')}</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Footer;